<template lang="pug">
v-list-item(@click="assignCode()") Verify
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["item"],
  methods: {
    ...mapActions(["updateInfluencer"]),
    async assignCode() {
      const params = { influencerId: this.item._id };
      try {
        const result = await this.$api.influencer.custom("verify", params);
        this.updateInfluencer(result);
      } catch (err) {
        this.$toast.error(err.response?.data || err.message);
      }
    },
  },
};
</script>
